import { Component, Input } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faConnectdevelop } from '@fortawesome/free-brands-svg-icons';
import {
  faChartSimple,
  faCode,
  faSquarePollVertical,
  faRobot,
  faSyncAlt,
  faChartLine,
  faComments,
  faNetworkWired,
  faDumbbell,
  faHospital,
  faMoneyBillWave,
  faMugHot,
  faUtensils,
  faHospitalSymbol,
  faStethoscope,
  faCreditCard,
  faPrescriptionBottleMedical,
  faUserShield,
  faShip,
  faHandshake,
  faUserPlus,
} from '@fortawesome/free-solid-svg-icons';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faAnchor } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-grid-cards-with-frame',
  templateUrl: './grid-cards-with-frame.component.html',
  styleUrls: ['./grid-cards-with-frame.component.css'],
})
export class GridCardsWithFrameComponent {
  @Input() data!: any;
  @Input() fileName!: string;
  @Input() language!: string;

  icons: { [key: string]: IconProp } = {
    faChartSimple,
    faCode,
    faSquarePollVertical,
    faRobot,
    faSyncAlt,
    faChartLine,
    faComments,
    faNetworkWired,
    faHospitalSymbol,
    faHospital,
    faUtensils,
    faDumbbell,
    faMugHot,
    faMoneyBillWave,
    faConnectdevelop,
    faAnchor,
    faStethoscope,
    faCreditCard,
    faPrescriptionBottleMedical,
    faUserShield,
    faShip,
    faHandshake,
    faUserPlus,
  };

  constructor(library: FaIconLibrary) {
    library.addIcons(
      faRobot,
      faSyncAlt,
      faChartLine,
      faComments,
      faNetworkWired,
      faHospitalSymbol,
      faHospital,
      faUtensils,
      faDumbbell,
      faMugHot,
      faMoneyBillWave,
      faChartSimple,
      faCode,
      faSquarePollVertical,
      faConnectdevelop,
      faAnchor,
      faStethoscope,
      faCreditCard,
      faPrescriptionBottleMedical,
      faUserShield,
      faShip,
      faHandshake,
      faUserPlus
    );
  }

  getDetailsUrl(object: any): string {
    return `/${this.language}/details/${this.fileName}/${object.title
      .replaceAll(' ', '-')
      .toLowerCase()}`;
  }
}
